import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service here
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="p-6 bg-red-50 rounded-xl border border-red-200">
          <h2 className="text-lg font-semibold text-red-800 mb-2">Something went wrong.</h2>
          <p className="text-red-600 text-sm mb-4">
            {this.props.fallbackMessage || 'A component failed to render.'}
          </p>
          <details className="whitespace-pre-wrap font-mono text-xs text-red-900 bg-red-100 p-4 rounded overflow-auto max-h-64">
            <summary className="font-semibold cursor-pointer mb-2">Error Details</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
